/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Required_Player_HintInputs */



/**
* | output |
* | --- |
* | "This tournament requires a decklist. Upload yours before check-in." |
*
* @param {Decks_Required_Player_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_required_player_hint = /** @type {((inputs?: Decks_Required_Player_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Required_Player_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce tournoi exige une decklist. Envoyez la vôtre avant de pointer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este torneo exige decklist. Suba la suya antes del check-in.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este torneio exige decklist. Envie a sua antes do check-in.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo torneo richiede una decklist. Caricala prima del check-in.")
	return /** @type {LocalizedString} */ ("This tournament requires a decklist. Upload yours before check-in.")
});